import { Pipe, PipeTransform } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faBook,
  faBorderAll,
  faChartLine,
  faCheck,
  faCircleExclamation,
  faEnvelope,
  faExclamation,
  faEye,
  faGear,
  faHourglassStart,
  faInfo,
  faListCheck,
  faMagnifyingGlass,
  faPaperPlane,
  faPause,
  faStamp,
  faTags,
  faTrash,
  faUser,
  faUsers,
  faWrench,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

@Pipe({
  name: 'icon',
})
export class IconPipe implements PipeTransform {
  private readonly iconRegistry = new Map<string, IconDefinition>([
    ['settings', faGear],
    ['workItems', faBorderAll],
    ['dashboard', faChartLine],
    ['tags', faTags],
    ['stamp', faStamp],
    ['eye', faEye],
    ['exclamation', faExclamation],
    ['listCheck', faListCheck],
    ['wrench', faWrench],
    ['info', faInfo],
    ['user', faUser],
    ['book', faBook],
    ['envelope', faEnvelope],
    ['users', faUsers],
    ['inProgress', faHourglassStart],
    ['x', faXmark],
    ['pause', faPause],
    ['check', faCheck],
    ['send', faPaperPlane],
    ['error', faCircleExclamation],
    ['trash', faTrash],
    ['search', faMagnifyingGlass],
  ]);

  transform(value: string): IconDefinition {
    return this.iconRegistry.get(value) ?? faGear;
  }
}
